import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Modal, Form, Input, DatePicker, Select, Space, message, Tag, Popconfirm } from 'antd';
import { PlusOutlined, DeleteOutlined, RocketOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getDelegatesList } from '../../redux/slices/delegates/delegatesThunk';
import axiosInstance from '../../services/axiosServicesVisit';
import dayjs from 'dayjs';

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  
  const delegates = useSelector((state) => state.delegates.delegatesList?.data?.data || []);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get('/v1/events');
      setEvents(res.data);
    } catch (e) { message.error("Erreur de chargement"); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchEvents();
    dispatch(getDelegatesList({ page: 1, itemsPerPage: 1000 }));
  }, [dispatch]);

  const handleSave = async (values) => {
    const payload = {
      name: values.name,
      date: values.date.format('YYYY-MM-DD'),
      delegateIds: values.delegateIds // Le backend s'occupe de la conversion
    };
    try {
      await axiosInstance.post('/v1/events', payload);
      message.success("Événement créé");
      setIsModalOpen(false);
      form.resetFields();
      fetchEvents();
    } catch (e) { message.error("Erreur lors de la création"); }
  };

  const handleDelete = async (id) => {
    await axiosInstance.delete(`/v1/events/${id}`);
    fetchEvents();
  };

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date', render: d => <b>{dayjs(d).format('DD/MM/YYYY')}</b> },
    { title: 'Nom', dataIndex: 'name', key: 'name', render: n => <Tag color="gold">{n.toUpperCase()}</Tag> },
    { 
      title: 'Participants', 
      dataIndex: 'delegates', 
      render: (dels) => dels?.map(d => <Tag key={d.id} icon={<RocketOutlined />}>{d.firstname} {d.lastname}</Tag>) 
    },
    {
      title: 'Action',
      render: (_, record) => (
        <Popconfirm title="Supprimer ?" onConfirm={() => handleDelete(record.id)}>
          <Button type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      )
    }
  ];

  return (
    <div className="tabled">
      <Card title="Gestion des Événements" extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => setIsModalOpen(true)}>Ajouter</Button>}>
        <Table dataSource={events} columns={columns} rowKey="id" loading={loading} />
      </Card>

      <Modal title="Nouvel Événement" open={isModalOpen} onOk={() => form.submit()} onCancel={() => setIsModalOpen(false)}>
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="name" label="Nom de l'événement" rules={[{required: true}]}><Input /></Form.Item>
          <Form.Item name="date" label="Date" rules={[{required: true}]}><DatePicker style={{width: '100%'}} /></Form.Item>
          <Form.Item name="delegateIds" label="Délégués" rules={[{required: true}]}>
            <Select mode="multiple" showSearch optionFilterProp="label">
              {delegates.map(d => <Select.Option key={d.id} value={d.id} label={`${d.firstname} ${d.lastname}`}>{d.firstname} {d.lastname}</Select.Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default EventsPage;